import { useCallback } from 'react';
import classNames from 'classnames';
import { useTranslator } from '@picsart/rc/services/localization';
import { Button, ButtonSizeMD, ButtonVariants } from '@picsart/button';

import Text from 'components/common/Text';

import { useHeaderStyles } from './styles';

interface IEraserHeaderProps {
  saveActive: boolean;
  onApply: () => void;
  onCancel: () => void;
  loading: boolean;
  isDarkMode: boolean;
}

const EraserHeader = ({
  saveActive, onApply, onCancel, loading, isDarkMode,
}: IEraserHeaderProps) => {
  const classes = useHeaderStyles({
    isDarkMode,
  });
  const translate = useTranslator();

  const canProceed = saveActive && !loading;

  const handleApply = useCallback(() => {
    if (canProceed) {
      onApply();
    }
  }, [onApply, canProceed]);

  return (
    <div className={classes.eraserHeader}>
      {!isDarkMode ? (
        <div className={classes.eraser}>{translate('Eraser')}</div>
      ) : (
        <Text size="large" weight="bold" color="secondary">
          {translate('Erase')}
        </Text>
      )}

      <div className={classes.cancelApplyContainer}>
        {!isDarkMode ? (
          <div className={classNames(classes.cancel, { [classes.disabledButton]: loading })} onClick={onCancel}>
            {translate('Cancel')}
          </div>
        ) : (
          <Button
            size={ButtonSizeMD}
            variant={ButtonVariants.Text}
            onClick={onCancel}
            className={classes.cancelNS}
          >
            {translate('Cancel')}
          </Button>
        )}

        {isDarkMode ? (
          <Button
            size={ButtonSizeMD}
            onClick={handleApply}
            isDisabled={!canProceed}
          >
            {translate('Apply')}
          </Button>
        ) : (
          <div
            className={classNames(classes.apply, classes.mainSettings,
              {
                [classes.disabledApply]: !canProceed,
                [classes.disabledButton]: !canProceed,
                [classes.hoverApply]: saveActive,
              })}
            onClick={handleApply}
          >
            {translate('Apply')}
          </div>
        )}
      </div>
    </div>
  );
};

export default EraserHeader;
